import * as sagaActions from "./sagaActions";
import { default as saga } from "./sagas";
import * as selectors from "./selectors";
import { actions as sliceActions } from "./slice";
export { default as reducer } from "./slice";
export { selectors, actions, saga };

const actions = {
  ...sliceActions,
  ...sagaActions,
};
